import { ReactNode } from "react";

import { TwcProvisioningScreen } from "../../views/twc-provisioning-screen/twc-provisioning-screen";
import JiraUserSegmentationView from "../../views/user-seg-bxp-ui/user-segmentation";
import { PerceivedProvisioningStartTimer } from "../perceived-provisioning/perceived-provisioning-start-timer";

import { PROVISIONING, ProvisioningScreenKey, TEAM_CHOICE } from "./utils";

export type ScreenList = ProvisioningScreenKey[];
export const teamChoiceDictionaryItem = {
    [TEAM_CHOICE]: <JiraUserSegmentationView />
} as const;
export const provisioningUIDictionaryItem = {
    [PROVISIONING]: (
        <PerceivedProvisioningStartTimer>
            <TwcProvisioningScreen />
        </PerceivedProvisioningStartTimer>
    )
} as const;
export type ScreenDictionary = Partial<
    Record<ProvisioningScreenKey, ReactNode>
>;

export const twcScreenDictionary: ScreenDictionary = {
    ...teamChoiceDictionaryItem,
    ...provisioningUIDictionaryItem
};
